import { useStickyNav } from './useStickyNav';

const STYLE_STICKY = 'is-stuck';
const STYLE_HIDE_LARGE = 'hide-large';

const stickySelector = '.js-sticky-panel';
const panelSelector = '.js-listing-panel-wrapper';
const panelPriceSelector = '.js-panel-display-price-container';

export const StickyNav = () => {
    const stickyEl = document.querySelector(stickySelector);
    const panelEl = document.querySelector(panelSelector);
    const panelPriceEl = document.querySelector(panelPriceSelector);
    const { isSticky } = useStickyNav(panelEl);

    if (isSticky) {
        stickyEl?.classList.add(STYLE_STICKY);
        panelPriceEl?.classList.remove(STYLE_HIDE_LARGE);
    } else {
        stickyEl?.classList.remove(STYLE_STICKY);
        panelPriceEl?.classList.add(STYLE_HIDE_LARGE);
    }
};
